import Image from "next/image";
import Link from "next/link";

const commonClasses =
	"flex items-center gap-1 px-2 py-1 text-sm truncate transition h-max w-max rounded-md";

const getTagClasses = (type?: string, isPremium?: boolean) => {
	if (isPremium) {
		if (type === "industries") {
			return "bg-blue-300 text-brand-primary";
		} else if (type === "tags") {
			return "bg-[orange] text-orange/10";
		}
	} else if (type === "industries") {
		return "bg-brand-primary/10 text-brand-primary";
	} else if (type === "tags") {
		return "bg-[orange]/10 text-orange-500";
	} else {
		return "text-gray-800";
	}
};

export const ProductTag = ({
	label,
	slug,
	icon,
	type = "tags",
	isPremium,
}: {
	label: string;
	slug?: string;
	icon?: string;
	type?: string;
	isPremium?: boolean;
}) => {
	const tagClasses = getTagClasses(type, isPremium);
	const finalClasses = `${commonClasses} ${tagClasses}`;

	const TagContent = (
		<span className="flex max-w-prose items-center gap-1 truncate" title={label}>
			{icon && <Image src={icon} alt={label} width={16} height={16} className="h-4 w-4" />}
			{label}
		</span>
	);

	return slug ? (
		<Link href={`/tags/${slug}`} className={finalClasses}>
			{TagContent}
		</Link>
	) : (
		<div className={finalClasses}>{TagContent}</div>
	);
};
